import { PillVariant } from "../../widget";

export class StandardConstants {
  public static readonly WOODLAND_CARBON_CODE_UUID = "eb6edf7d-7f43-4440-83c9-f310c276548a";

  public static readonly PEATLAND_CODE_UUID = "3b0c9c25-9bd4-4563-87a7-3cd94823908c";

  public static readonly UK_CARBON_CODE_OF_CONDUCT_CODE_UUID = "daeb58f6-759c-4f3e-9de5-e19633e93972";

  public static readonly WILDER_CARBON_UUID = "a30690b5-70ec-44f8-9d88-d7968db298b3";

  public static readonly PURO_EARTH_UUID = "acedbad7-30ad-4b06-8799-5d1dfb09871d";

  public static readonly CODE_PILL_VARIANT_MAP: { [key: string]: PillVariant } = {
    "Woodland Carbon Code": "green",
    "Peatland Code": "coral",
    "Wilder Carbon Standard": "blue",
    "UK Carbon Code of Conduct": "cyan",
    "Hedgerow Carbon Code": "yellow",
    "Puro.earth": "pink",
    "Natural Flood Management": "blue",
    CreditNature: "purple",
    "Biodiversity Net Gain": "purple",
    "No standard": "grey",
    "Gold Standard": "cyan",
    Algapelago: "blue",
    "30x30 UK": "blue",
    "Nutrient Neutrality": "blue",
    Verra: "green",
  };
}
